var y = Object.defineProperty, b = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var _ = (o, e, t) => e in o ? y(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, g = (o, e) => {
  for (var t in e || (e = {}))
    r.call(e, t) && _(o, t, e[t]);
  if (c)
    for (var t of c(e))
      s.call(e, t) && _(o, t, e[t]);
  return o;
}, h = (o, e) => b(o, p(e));
var f = (o, e) => {
  var t = {};
  for (var i in o)
    r.call(o, i) && e.indexOf(i) < 0 && (t[i] = o[i]);
  if (o != null && c)
    for (var i of c(o))
      e.indexOf(i) < 0 && s.call(o, i) && (t[i] = o[i]);
  return t;
};
import x from "clsx";
import { createElement as N } from "react";
const T = "_bodyText_1hg66_1", C = "_fontSize12_1hg66_6", u = "_fontSize14_1hg66_10", M = "_fontSize16_1hg66_14", w = "_fontSize24_1hg66_18", B = "_lineHeight1572_1hg66_22", E = "_lineHeight1714_1hg66_26", j = "_lineHeight1500_1hg66_30", k = "_color0_1hg66_34", q = "_color1_1hg66_38", v = "_color2_1hg66_42", A = "_color3_1hg66_46", D = "_color4_1hg66_50", n = {
  bodyText: T,
  fontSize12: C,
  fontSize14: u,
  fontSize16: M,
  fontSize24: w,
  lineHeight1572: B,
  lineHeight1714: E,
  lineHeight1500: j,
  color0: k,
  color1: q,
  color2: v,
  color3: A,
  color4: D
};
function K(F) {
  var l = F, {
    as: o = "p",
    fontSize: e = "1.4rem",
    lineHeight: t = "1.572",
    color: i = "body-0",
    className: a
  } = l, z = f(l, [
    "as",
    "fontSize",
    "lineHeight",
    "color",
    "className"
  ]);
  const S = {
    "1.2rem": n.fontSize12,
    "1.4rem": n.fontSize14,
    "1.6rem": n.fontSize16,
    "2.4rem": n.fontSize24
  }, m = {
    1.572: n.lineHeight1572,
    1.714: n.lineHeight1714,
    "1.500": n.lineHeight1500
  }, H = {
    "body-0": n.color0,
    "body-1": n.color1,
    "body-2": n.color2,
    "body-3": n.color3,
    "body-4": n.color4
  }, d = x(
    n.bodyText,
    S[e],
    m[t],
    H[i],
    a
  );
  return N(o, h(g({}, z), {
    className: d
  }));
}
export {
  K as default
};
